<template>
  <v-data-table :headers="headers" :search="search" :items="desserts" sort-by="created_at" class="elevation-1">
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Agence</v-toolbar-title> 
        <v-spacer></v-spacer> 
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Rechercher" single-line hide-details></v-text-field> 
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="800px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">Nouvelle Agence</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                   <v-col cols="12" sm="4" md="4">
                    <v-text-field v-model="editedItem.agency" label="Agence"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field v-model="editedItem.phone" label="Téléphone"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field v-model="editedItem.email" label="Email"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" text @click="close">Annuler</v-btn>
              <v-btn color="green" text @click="save">Valider</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="headline">Êtes-vous sûr de supprimer ?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" text @click="closeDelete">Cancel</v-btn>
              <v-btn color="green" text @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDetailsAgency" max-width="1000%" max-h>
          <v-card max-width="1000%" style="background-color: #ebebeb !important;">
            <div style="font-weight: bold; text-align:center !important;margin:30px;font-size:40px;">Details Agence</div>
            <v-card-text max-width="1000%">
              <v-container style="width: 100% !important;max-width: 100%;">
                <v-card>
                  <v-row>
                    <v-col cols="12" sm="12" md="12" style="text-align:center;color:black;font-size:40px;">info</v-col>
                  </v-row>
                  <v-row style="height: 100px;">
                    <v-col cols="12" sm="4" md="4" style="text-align:center;">
                      Nom : <span style="margin:20px !important;">{{ editedItem.agency }}</span>
                    </v-col>
                    <v-col cols="12" sm="4" md="4" style="text-align:center;">
                      Tele : <span style="margin:20px !important;">{{ editedItem.phone }}</span>
                    </v-col>
                    <v-col cols="12" sm="4" md="4" style="text-align:center;">
                      email : <span style="margin:20px !important;">{{ editedItem.email }}</span>
                    </v-col>
                  </v-row>
                </v-card>
                <br><br>
                <v-card>
                  <v-row>
                    <v-col cols="12" sm="12" md="12" style="text-align:center;color:black;font-size:40px;">Filter</v-col>
                  </v-row>
                    <v-row style="margin:2px;">
                      <!-- <v-col cols="12" sm="1" md="1"></v-col> -->
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field v-model="itemSearch.date1" label="Date1" type="date"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field v-model="itemSearch.date2" label="Date2" type="date"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="12" style="text-align:center;">
                      <v-btn color="green" text @click="filterdetailAgency()">Valider</v-btn>
                    </v-col>
                  </v-row>
                </v-card>
                <br><br>
                <div class="row">
                    <v-col cols="12" sm="12" md="12" style="text-align:center;color:black;font-size:40px;">Ventes {{ totalVentes }} Dhs</v-col>
                </div>
                <br>
                <v-data-table :headers="headerVentes" :items="dessertVentes" sort-by="created_at" class="elevation-2 table"></v-data-table>
                <!-- <br><br> -->

                <!-- <div class="row">
                    <v-col cols="12" sm="12" md="12" style="text-align:center;color:black;font-size:40px;">Primes {{ totalPrimes }} Dhs</v-col>
                </div> -->

                <!-- <br> -->

                <!-- <v-data-table :headers="headerPrimes" :items="dessertPrimes" sort-by="created_at" class="elevation-2"></v-data-table> -->
                
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <!-- <v-btn color="red" text @click="closeDelete">Cancel</v-btn> -->
              <v-btn color="primary" text @click="closeDialogDetail()">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:[`item.agency`]="{ item }">
        <span @click="showDetailsAgency(item)" style="color: #2196F3;cursor: pointer;">{{item.agency}}</span>
    </template>
    <template v-slot:[`item.benefice`]="{ item }">
        <span v-if="item.benefice >= 0" style="color:green;">{{item.benefice}}</span>
        <span v-if="item.benefice < 0" style="color:red;">{{item.benefice}}</span>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon small color="blue" class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
      <!-- <v-icon small color="red" @click="deleteItem(item)">mdi-delete</v-icon> -->
    </template>
  </v-data-table>
</template>

<style scoped>
.table tr td {
    border-bottom: none !important;
}
</style>

<script>
import axios from 'axios';
  export default {
    data(){
    return {
      search: '',
      dialog: false,
      dialogDelete: false,
      dialogDetailsAgency :false,
      itemSearch :{
        date1 : '',
        date2 : ''
      },
      // localhost:'http://localhost:8000/api',
      localhost:'https://guide.artnaji.com/index.php/api',
      headers: [
        { text: 'Agence', value: 'agency' },
        { text: 'Téléphone', value: 'phone',},
        { text: 'Email', value: 'email' },
        { text: "date d'ajoute", value: 'created_at' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      headerVentes: [
        { text: 'Guide', value: 'guide.guide'},
        { text: 'Passage', value: 'passage'},
        { text: 'Accompagnateur', value: 'accompagnateur.guide'},
        { text: 'Vente', value: 'vente' },
        { text: '% guide', value: 'commission' },
        { text: 'Règ guide', value: 'reglement_guide' },
        { text: '% agence', value: 'commission_agency' },
        { text: 'Règ agence', value: 'reglement_agency' },
        { text: 'Date', value: 'date_vente' },
      ],
      headerPrimes : [
        { text: 'Montant', value: 'amount',},
        { text: 'date', value: 'date_prime',},
      ],
      dessertPrimes : [],
      dessertVentes : [],
      desserts: [],
      editedIndex: -1,
      // operation:'dd',
      // editedItem : [],
      editedItem: {
        name: name,
        title: '',
        price: 0,
        wholesaleprice: 0,
        quantity: 0,
      },
      
      defaultItem: {
        name: '',
        title: '',
        price: 0,
        wholesaleprice: 0,
        quantity: 0,
      },
    }
    },

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nouvelle Agence' : 'Modifier Agence'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      if(!localStorage.getItem('user-token')){
        window.location.href = '../App';
      }
      this.initialize()
    },

    methods: {
      initialize () {
        let datesearch = new Date()
        this.itemSearch.date1 = datesearch.getFullYear()+"-01-01" 
        this.itemSearch.date2 = datesearch.getFullYear()+"-12-31"
        axios.get(this.localhost+'/agency'
        // ,{
        //   headers:{
        //     'Authorization': 'Bearer '+localStorage.getItem('user-token')
        //   }
        // }
        )
        .then(response => {
          this.desserts = []
          response.data.forEach(element => {
            element.created_at = new Date(element.created_at).toISOString().substr(0, 10)
            this.desserts.push(element)
          });
        })
      },
      editItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      filterdetailAgency(){
        this.dessertVentes = []
        this.dessertPrimes = []
        this.totalVentes = 0
        this.totalPrimes = 0
        this.totalReglement = 0
        axios.post(this.localhost+'/agency/'+this.editedItem.id+'/details',this.itemSearch).then(response=>{
          console.log(response.data);
          this.dessertVentes = response.data.ventes
          this.dessertPrimes = response.data.primes
          this.totalVentes = response.data.totalVentes
          this.totalPrimes = response.data.totalPrimes 
          this.totalReglement = response.data.totalreglements
        })
      },

      showDetailsAgency(item){
        this.dessertVentes = []
        this.dessertPrimes = []
        this.totalVentes = 0
        this.totalPrimes = 0
        this.totalReglement = 0
        this.editedItem = item
        this.itemSearch.date1 = "2021-01-01" 
        this.itemSearch.date2 = "2021-12-31"
        axios.post(this.localhost+'/agency/'+item.id+'/details',this.itemSearch).then(response=>{
          console.log(response.data);
          this.dessertVentes = response.data.ventes
          this.dessertPrimes = response.data.primes
          this.totalVentes = response.data.totalVentes
          this.totalPrimes = response.data.totalPrimes 
          this.totalReglement = response.data.totalreglements
        })
        this.dialogDetailsAgency=true
      },

      closeDialogDetail(){
        this.dialogDetailsAgency=false
      },

      deleteItemConfirm () {
        axios.delete(this.localhost+'/agency/'+this.editedItem.id).then(response=>{
            console.log(response)
        })
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (this.editedIndex > -1) {
         axios.put(this.localhost+'/agency/'+this.editedItem.id,this.editedItem).then(response=>{
           console.log(response)
           this.initialize()
         })  
        } else {
         axios.post(this.localhost+'/agency',this.editedItem).then(response=>{
           console.log(response)
           this.initialize()
         }) 
        }
        this.close()
      },
    },
  }
</script>